// src/components/FileUpload.tsx

import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
import {
  BrowseText,
  DeleteButtonStyled,
  DropzoneWrapper,
  PreviewContainer
} from './styled';
import Icons from '../icons';

interface FileUploadProps {
  title: string;
  name: string;
  value: string | null | undefined;
  uploadHandler: (file: File, uploadFor: string) => Promise<string>;
  onChange: (url: string) => void;
  onRemove: () => void;
  disabled?: boolean;
  uploadFor: string;
}

const FileUploadWithPreview = ({
  title,
  name,
  value,
  uploadHandler,
  onChange,
  onRemove,
  disabled,
  uploadFor
}: FileUploadProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  const triggerFileUpload = () => {
    inputRef.current?.click();
  };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      const file = e.target.files[0];
      try {
        const url = await uploadHandler(file, uploadFor);
        onChange(url);
      } catch (err) {
        console.error('Upload failed', err);
      }
    }
  };

  return (
    <Box mt={4} mb={2}>
      <Typography variant='h6' component='h3' gutterBottom>
        {title}
      </Typography>

      <input
        id={`${name}-upload-input`}
        ref={inputRef}
        type='file'
        hidden
        accept='image/*'
        name={name}
        onChange={handleFileUpload}
        aria-label={`Upload ${name}`}
        disabled={disabled} // Apply disabled prop
      />

      {!value ? (
        <Box display='flex' flexDirection='column'>
          <DropzoneWrapper
            onClick={disabled ? undefined : triggerFileUpload} // Disable click if disabled
            width='100%'
            maxWidth='600px'
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }} // Change cursor
          >
            <Icons.Delete
              style={{ fontSize: 48, color: disabled ? '#e0e0e0' : '#90a4ae' }}
            />

            <Typography variant='body2' color='textSecondary'>
              <BrowseText>Browse files</BrowseText> on your computer
            </Typography>
          </DropzoneWrapper>
        </Box>
      ) : (
        <Box>
          <PreviewContainer>
            <img
              src={value}
              alt='File Preview'
              style={{
                maxHeight: 200,
                maxWidth: 250,
                display: 'block',
                objectFit: 'contain'
              }}
            />
            <Tooltip title={`Remove ${name}`}>
              {/* Using the new styled delete button */}
              <DeleteButtonStyled
                size='small'
                onClick={onRemove}
                disabled={disabled}
              >
                {' '}
                {/* Apply disabled prop */}
                <Icons.Delete fontSize='small' />
              </DeleteButtonStyled>
            </Tooltip>
          </PreviewContainer>
        </Box>
      )}
    </Box>
  );
};

FileUploadWithPreview.defaultProps = {
  disabled: false
};

export default FileUploadWithPreview;
